export const userComplaintsQuery = ({ auth, profile }) => {
  if (profile.role === 'complainant') {
    return [
      {
        collection: 'complaints',
        where: ['complainant.uid', '==', auth.uid],
        orderBy: 'created',
        limit: 50,
        storeAs: 'complaints',
      },
    ];
  }

  if (profile.role === 'manager') {
    return [
      {
        collection: 'complaints',
        //where: [ 'complainant.uid', '==', auth.uid ],
        where: ['status', 'in', ['open', 'processing', 'overdue']],
        // where: ['sectors', '==', []],
        orderBy: ['created', 'desc'],
        limit: 900,
        storeAs: 'complaints',
      },
    ];
  }
  else if (profile.role === 'agent' || profile.role === 'temp-agent') {
    return [
      {
        collection: 'complaints',
        where: ['status', 'in', ['open', 'processing', 'overdue']],
        orderBy: ['created', 'desc'],
        limit: 700,
        storeAs: 'complaints',
      },
    ];
  } else {
    return [];
  }
};

export const userEmailQueries = ({ auth }) => {
  return [
    {
      path: 'emails',
    },
  ];
};

export const userActivities = ({ auth, profile }) => {
  if (profile.role !== 'manager') {
    return [
      {
        path: `activities/${profile.uid}`,
        queryParams: ['orderByChild=createdAt', 'limitToLast=20'],
        storeAs: 'activities',
      },
    ];
  }
  if (profile.role === 'manager') {
    return [
      {
        path: `activities/manager`,
        queryParams: ['orderByChild=createdAt', 'limitToLast=100'],
        storeAs: 'activities',
      },
    ];
  } else {
    return [];
  }
};

export const contactMessages = ({ auth, profile }) => {
  if (profile.role === 'manager' || profile.role === 'agent') {
    return [
      {
        path: `contactMessages`,
        storeAs: 'contactMessages',
      },
    ];
  } else {
    return [];
  }
};
